import messages from '../../../locale/messages';

const validate = (values) => {
  const errors = {};

  if (!values.listId) {
    errors.listId = messages.required;
  }

  if (!values.guestId) {
    errors.guestId = messages.required;
  }

  if (!values.checkIn) {
    errors.checkIn = messages.required;
  }

  if (!values.checkOut) {
    errors.checkOut = messages.required;
  }

  if (values.checkIn && values.checkOut && values.checkOut < values.checkIn) {
    errors.checkOut = messages.required;
  }

  if (values.startTime === undefined || values.startTime === null || values.startTime === '') {
    errors.startTime = messages.required;
  }

  if (values.endTime === undefined || values.endTime === null || values.endTime === '') {
    errors.endTime = messages.required;
  }

  return errors;
};

export default validate;
